import React from "react"
import { useRouteMatch } from "react-router-dom"
import {
  KNOWMAP_KNOWCRED_AWARDED,
  KNOWMAP_KNOWCRED_VALID,
} from "../../../../../library/constants/routes"
import { useDispatch, useSelector } from "react-redux"
import GridList from "../../../../../components/ui/grid"
import {
  clearLearnerKnowmapKnowcreds,
  getLearnerKnowmapKnowcreds,
} from "../../../../../library/store/actions/creators/knowmapCreators"
import KnowCredCard from "../../../knowCred/knowCredCard"
import ListPage from "../../../../../components/v2/layout/listPage/listPage"

const tabs = [
  {
    label: "Valid",
    path: KNOWMAP_KNOWCRED_VALID,
  },
  {
    label: "Awarded",
    path: KNOWMAP_KNOWCRED_AWARDED,
  },
].filter(Boolean)

const KnowmapLearnerKnowcred = () => {
  const dispatch = useDispatch()
  const { path } = useRouteMatch()
  const { learnerKnowcred, learnerKnowcredEndReached } = useSelector(
    ({ knowmap }) => knowmap
  )

  // const statusType = path === KNOWMAP_KNOWCRED_AWARDED ? 2 : 3
  return (
    <>
      <ListPage
        // Header={() => (
        //   <ListPageTabsHeader
        //     tabs={tabs}
        //     noResults={false}
        //     noResultsLabel={'No results'}
        //   />
        // )}
        title={"Creds"}
        list={learnerKnowcred}
        listEndReached={learnerKnowcredEndReached}
        ListContainer={GridList}
        getList={async ({ name: title, offset }) => {
          await dispatch(
            getLearnerKnowmapKnowcreds({
              // status_type: statusType,
              // type,
              title,
              offset,
            })
          )
        }}
        clearList={() => dispatch(clearLearnerKnowmapKnowcreds())}
        getListItemComponent={({ item }) => (
          <KnowCredCard knowCred={item} key={item.id} />
        )}
      />
    </>
  )
}

export default KnowmapLearnerKnowcred
